import { List as MuiList, ListProps as MuiListProps } from "@mui/material";

interface ListProps extends MuiListProps {
  children?: React.ReactNode;
}

export const List: React.FC<ListProps> = ({ children, ...props }) => {
  return <MuiList {...props}> {children}</MuiList>;
};

export default List;
